export default [
    {
        path: "",
        component: "dashboard",
        text: "Dashboard",
        roles: ["*"],
        icon: "mdi-view-dashboard",
    },
    {
        path: "affectation",
        component: "assignment",
        roles: ["commercial_director"],
        icon: "mdi-account-arrow-left",
    },
    {
        path: "agenda",
        component: "agenda",
        roles: ["*"],
        icon: "mdi-calendar",
    },
    {
        path: "carte",
        component: "mapsPage",
        text: "Carte",
        roles: ["commercial", "metreur"],
        icon: "mdi-map",
    },
    {
        path: "classement",
        component: "ranking2",
        roles: ["commercial_director", "commercial"],
        text: "Classement",
        icon: "mdi-podium-gold",
    },
    {
        path: "suivi-client",
        component: "suiviClient",
        roles: ["assistant"],
        text: "Suivi client",
        icon: "mdi-account-multiple-check",
    },
    {
        path: "contact",
        component: "contacts",
        roles: ["commercial"],
        icon: "mdi-account-arrow-right",
    },
    {
        path: "client",
        component: "customers",
        roles: ["commercial", "metreur"],
        text: "Mes clients",
        icon: "mdi-account-multiple",
    },
    {
        path: "intervention-commercial",
        component: "interventions-commercial",
        roles: ["commercial"],
        text: "Suivi interventions",
        icon: "mdi-calendar-week",
    },
    {
        // Planning de pose de l'equipe (F3) : pas dans le menu, l'acces depend des droits Lola
        // verifies par l'API ; entrees depuis les pages d'interventions et l'agenda
        path: "planning-pose",
        component: "planning-pose",
        roles: ["*"],
        text: "Planning de pose",
        icon: "mdi-account-hard-hat",
        drawer: false,
    },
    {
        path: "intervention-technicien",
        component: "interventions-technicien",
        roles: ["technician", "technical_director"],
        text: "Mes interventions",
        icon: "mdi-calendar-week",
    },
    {
        path: "reclamations-sav",
        component: "reclamations-sav",
        roles: ["technician"],
        text: "Réclamations SAV",
        icon: "mdi-alert-circle",
    },
    {
        path: "intervention-metreur",
        component: "interventions-metreur",
        roles: ["metreur"],
        text: "Liaison interventions",
        icon: "mdi-calendar-week",
    },
    {
        path: "devis",
        component: "quotes",
        roles: ["commercial"],
        text: "Relances devis",
        icon: "mdi-file-document",
    },
    {
        path: "raf",
        component: "raf",
        roles: ["*"],
        text: "RAF à saisir",
        icon: "mdi-account-question",
        drawer: true,
    },
    {
        path: "rapport",
        component: "rapport",
        roles: ["*"],
        drawer: false,
        icon: "mdi-form-select",
    },
    {
        path: "prospection",
        component: "prospection",
        roles: ["commercial_director", "commercial"],
        text: "Prospection",
        icon: "mdi-account-question",
        drawer: true,
    },
    {
        path: "relance",
        component: "relaunch",
        roles: ["commercial"],
        text: "Relances",
        icon: "mdi-account-alert",
        drawer: false,
    },
    {
        path: "suivi",
        component: "suivi2",
        roles: ["commercial_director"],

        text: "Suivi",
        icon: "mdi-chart-line",
    },
    {
        path: "intervention/:id/sign",
        component: "interventionSign",
        drawer: false,
    },
    {
        path: "telescope",
        component: "telescopePage",
        text: "Telescope",
        roles: ["commercial_director", "technical_director"],
        icon: "mdi-telescope",
        drawer: false,
    },
    {
        path: "telescope/:uuid",
        name: "telescope.show",
        component: "telescopeShowPage",
        drawer: false,
    },
]
